import { MarkdownContent } from '@backstage/core-components';

import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    width: 480,
    maxWidth: '90vw',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2, 1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
  markdown: {
    fontSize: theme.typography.subtitle1.fontSize,
    '& p': {
      fontSize: theme.typography.subtitle1.fontSize,
    },
  },
}));

export interface InfoDocDialogProps {
  dialogTitle: string;
  infoDoc: string;
  open: boolean;
  onClose?: () => void;
}

/** Side drawer holding the long-form markdown help for a scaffolder field. */
export const InfoDocDialog = ({
  dialogTitle,
  infoDoc,
  open,
  onClose,
}: InfoDocDialogProps) => {
  const { classes } = useStyles();

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <Typography variant="h6">{dialogTitle}</Typography>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={classes.content}>
          <MarkdownContent content={infoDoc} className={classes.markdown} />
        </Box>
      </Box>
    </Drawer>
  );
};
